import 'choerodon-ui/lib/skeleton/style';
